// Rotating greeting copy. Picks from a list of options so the home screen
// feels alive rather than scripted. Cached in localStorage and refreshed at
// most once per 24h so the user isn't whiplashed on every nav.

const GREETINGS = [
  'Bonjour, {name}',
  'Salut, {name}',
  'Bon shift, {name}',
  'Bienvenue, {name}',
  'Prêt à sauver des vies, {name} ?',
  'Café d’abord, médecine ensuite, {name}',
  'Allô, {name}',
  'En selle, Dr. {name}',
  'Ça va brasser, {name} ?',
  'Bonne pratique, {name}',
  'Hey, {name}',
  'Encore une journée tranquille, hein {name} ?',
  'Le triage t’attend, {name}',
  'L’urgence est servie, {name}',
];

const FALLBACK_NONAME = [
  'Bonjour',
  'Salut',
  'Bon shift',
  'Bienvenue',
  'Allô',
  'Prêt à sauver des vies ?',
  'Café d’abord, médecine ensuite',
  'L’urgence est servie',
];

const STORAGE_KEY = 'greeting.cache.v1';
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

type Cached = { text: string; pickedAt: number; nameKey: string };

function readCache(): Cached | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.text === 'string' && typeof parsed?.pickedAt === 'number') {
      return parsed as Cached;
    }
  } catch {
    // ignore
  }
  return null;
}

function writeCache(c: Cached) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(c));
  } catch {
    // ignore quota / disabled storage
  }
}

function pickFresh(name: string): string {
  if (!name) {
    return FALLBACK_NONAME[Math.floor(Math.random() * FALLBACK_NONAME.length)];
  }
  const tpl = GREETINGS[Math.floor(Math.random() * GREETINGS.length)];
  return tpl.replace('{name}', name);
}

export function greetingFor(firstName: string | null | undefined): string {
  const name = (firstName ?? '').trim();
  const nameKey = name.toLowerCase();
  const cached = readCache();
  const fresh =
    cached &&
    cached.nameKey === nameKey &&
    Date.now() - cached.pickedAt < ONE_DAY_MS;
  if (fresh) return cached.text;
  const text = pickFresh(name);
  writeCache({ text, pickedAt: Date.now(), nameKey });
  return text;
}
